'use client';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { useAuth } from '@/lib/auth/AuthProvider';
import { isAdmin } from '@/lib/auth/roles';

export const PUPPY_APPLICATIONS_FLAG = 'puppy_applications';
export const PUPPY_APPLICATIONS_ADMIN_ONLY_FLAG =
  'puppy_applications.admin_only';

export function usePuppyApplicationsEnabled(): {
  isEnabled: boolean;
  isLoading: boolean;
} {
  const { isEnabled: flagEnabled, isLoading } = useFeatureFlags();
  const { session } = useAuth();

  if (!flagEnabled(PUPPY_APPLICATIONS_FLAG)) {
    return { isEnabled: false, isLoading };
  }

  if (flagEnabled(PUPPY_APPLICATIONS_ADMIN_ONLY_FLAG) && !isAdmin(session)) {
    return { isEnabled: false, isLoading };
  }

  return { isEnabled: true, isLoading };
}
